


























































































































































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {InputFaturamentoSchema} from '@/schema/resource/Faturamento/InputFaturamentoSchema'
import {FaturamentoConfiguracao} from '@/model/resource/FaturamentoConfiguracao'
import ModalExportReport from '@/components/modals/ModalExportReport.vue'
import {InputFaixaFaturamentoSchema} from '@/schema/resource/Faturamento/InputFaixaFaturamentoSchema'
import {FaixaValorFaturamento} from '@/model/resource/FaixaValorFaturamento'

@Component({
  components: {ModalExportReport},
})
export default class PersistFaturamentoConfiguracaoView extends Vue {
  @Provide('validator') validator = this.$validator

  schema = new InputFaturamentoSchema()
  faturamento = new FaturamentoConfiguracao()
  listaFaixaFaturamento: FaixaValorFaturamento[] = []

  async created() {
    await this.populate()
  }

  toggleAddNew() {
    const faixaValorFaturamento = new FaixaValorFaturamento()
    faixaValorFaturamento.idResponsavelFk = this.faturamento.idResponsavelFk
    this.listaFaixaFaturamento.push(faixaValorFaturamento)
  }

  async removeFaixa(index: number) {
    this.listaFaixaFaturamento.splice(index, 1)
  }

  @Watch('faturamento.responsavel')
  async populate() {
    const idResponsavel = this.faturamento?.responsavel?.$id

    if (idResponsavel) {
      const resp = await this.faturamento.getFaturamentoConfiguracao(
        idResponsavel
      )
      if (!resp) {
        this.faturamento.reset()
        this.listaFaixaFaturamento = []
        this.toggleAddNew()
        this.$snotify.warning(
          $.t('schema.InputFaturamentoConfiguracao.warning') as string
        )
      } else {
        if (this.faturamento.listaFaixaValorFaturamento.length === 0) {
          this.listaFaixaFaturamento = []
          this.toggleAddNew()
        } else {
          this.listaFaixaFaturamento = this.faturamento.listaFaixaValorFaturamento
        }
      }
    } else {
      this.faturamento.reset()
      this.listaFaixaFaturamento = []
    }

    $.await.done('getFaturamentoConfiguracao')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    if ((this.faturamento.diaInicial?.toString() || '') == '') {
      this.faturamento.diaInicial = null
    }

    if ((this.faturamento.diaFinal?.toString() || '') == '') {
      this.faturamento.diaFinal = null
    }

    if (this.listaFaixaFaturamento.length > 0) {
      this.listaFaixaFaturamento.forEach((item, index) => {
        if (
          (item.nomeFaixa === null || item.nomeFaixa === '') &&
          item.volumeInicial === null &&
          item.volumeFinal === null
        ) {
          this.removeFaixa(index)
        }
      })
      this.faturamento.listaFaixaValorFaturamento = this.listaFaixaFaturamento
    }

    await this.faturamento.persistFaturamentoConfiguracao()
    this.$snotify.success(
      $.t('schema.InputFaturamentoConfiguracao.success') as string
    )
    this.faturamento.restart()
    this.$forceUpdate()
  }

  async exportReport() {
    this.$modal.open('exportReport', this.faturamento)
  }

  get responsavelLabelAndValue() {
    if (this.faturamento.responsavel?.razaoSocial) {
      return {
        label: $.t('schema.InputFaturamentoConfiguracao.razaoSocial'),
        value: this.faturamento.responsavel.razaoSocial,
      }
    } else {
      return {
        label: $.t('schema.InputFaturamentoConfiguracao.nomeFantasia'),
        value: this.faturamento.responsavel?.nomeFantasia,
      }
    }
  }
}
